import axios, { AxiosResponse } from 'axios'
import { ClienteDtoCreate, ClienteDtoUpdate, ClienteQueryResponse, ClienteView } from './_models'
import { ID } from '../../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const EMPRESAS_CLIENTE_URL = `${API_URL}/empresas/cliente`

export const getEmpresasCliente = (query: string): Promise<ClienteQueryResponse> => {
  return axios
    .get(`${EMPRESAS_CLIENTE_URL}?${query}`)
    .then((d: AxiosResponse<ClienteQueryResponse>) => d.data)
}

export const getEmpresaClienteById = (idEmpresaCliente: ID): Promise<ClienteView> => {
  return axios
    .get(`${EMPRESAS_CLIENTE_URL}/${idEmpresaCliente}`)
    .then((response: AxiosResponse<ClienteView>) => response.data)
}

export const getEmpresaClienteAso = (
  idEmpresa: ID,
  query: string
): Promise<ClienteQueryResponse> => {
  //MUDAR PARA MANDAR POR SEARCH O IDMEPRESA
  return axios
    .get(`${EMPRESAS_CLIENTE_URL}?idEmpresa=${idEmpresa}&${query}`)
    .then((d: AxiosResponse<ClienteQueryResponse>) => d.data)
}

/**
 * Cria uma empresa cliente ligada a empresa mãe
 * @param idEmpresa Identificador da empresa mãe
 * @param cliente Objeto ClienteDtoCreate
 * @returns ClienteView
 */
export const createEmpresaCliente = (
  idEmpresa: ID,
  cliente: ClienteDtoCreate
): Promise<ClienteView> => {
  return axios
    .post(`${EMPRESAS_CLIENTE_URL}/${idEmpresa}`, cliente)
    .then((resp: AxiosResponse<ClienteView>) => resp.data)
}

/**
 * Atualiza o cadastro de uma empresa cliente
 * @param idEmpresaCliente Identificador da empresa cliente
 * @param cliente Objeto ClienteDtoUpdate
 * @returns ClienteView
 */
export const updateEmpresaCliente = (
  idEmpresaCliente: ID,
  cliente: ClienteDtoUpdate
): Promise<ClienteView> => {
  return axios
    .put(`${EMPRESAS_CLIENTE_URL}/${idEmpresaCliente}`, cliente)
    .then((resp: AxiosResponse<ClienteView>) => resp.data)
}

/**
 * Exclui uma empresa cliente (empregador ASO)
 * @param idEmpresaCliente Identificador da empresa cliente
 */
export const deleteEmpresaCliente = (idEmpresaCliente: ID): Promise<void> => {
  return axios.delete(`${EMPRESAS_CLIENTE_URL}/${idEmpresaCliente}`).then(() => {})
}

/**
 * Exclui várias empresas cliente. O backend não tem exclusão em lote: dispara uma requisição
 * por id, em paralelo, e rejeita se qualquer uma falhar.
 * @param idsEmpresaCliente Identificadores das empresas cliente
 */
export const deleteSelectedEmpresaCliente = (idsEmpresaCliente: Array<ID>): Promise<void> => {
  return Promise.all(idsEmpresaCliente.map(deleteEmpresaCliente)).then(() => {})
}
